<template>
    <section class="tekst orange">
        <circles-layout class="orange"></circles-layout>
        <h1>Opleiden voor een carri&egrave;re</h1>
        <p>Wij willen studenten goed voorbereiden op een carrière binnen een voortdurend veranderende arbeidsmarkt. Daar is veel aanpassingsvermogen voor nodig. Zo moeten we ervoor zorgen dat opleidingen goed op elkaar aansluiten zodat studenten moeiteloos kunnen switchen tussen opleidingen en leerwegen of doorstromen naar hogere niveaus. De studieloopbaanbegeleiders en STAP013 spelen hierin een belangrijke rol.</p>

        <p>Het leven lang leren is een belangrijk uitgangspunt voor onze instelling. Onze scholen worden ondersteund door een programmamanager om dit aanbod verder te ontwikkelen. In 2020 is er een aanbod ontwikkeld in de derde leerweg, om nog beter invulling te geven aan wat de omgeving van ons vraagt.</p>

        <p>Voor de studenten die willen doorstromen naar het hbo, verbeterden we samen met Fontys de aansluiting tussen de onderwijsinstellingen. Dit onder andere door het inzetten van student-mentoren, meeloopprogramma’s voor studenten, keuzedelen doorstroom hbo en gezamenlijke voorlichtingsmomenten.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'CarriereIntro',
        meta: {
            title: 'CarriereIntro',
            color: '#FE5D0B'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
